import React from "react";
import { Container, Box, useTheme, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const HowToJoin = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <Container>
      <Box my={4}>
        <Typography
          variant="h6"
          component="h6"
          fontWeight={800}
          color={theme.palette.primary.main}
        >
          {t("tutorial.join.title")}
        </Typography>
        {/* <Typography variant="body1" component="div" fontWeight={800}>
          {t("tutorial.join.title")}
        </Typography> */}
        <Typography variant="body2" component="div">
          {t("tutorial.join.desc")}
        </Typography>
        <br />
        <Typography variant="body2" component="div">
          {t("tutorial.join.list.title")}
        </Typography>
        <Typography variant="body2" component="div">
          <ol>
            <li style={{ margin: "16px" }}>{t("tutorial.join.list.1")}</li>
            <li style={{ margin: "16px" }}>{t("tutorial.join.list.2")}</li>
            <li style={{ margin: "16px" }}>{t("tutorial.join.list.3")}</li>
            <li style={{ margin: "16px" }}>{t("tutorial.join.list.4")}</li>
            <li style={{ margin: "16px" }}>{t("tutorial.join.list.5")}</li>
          </ol>
        </Typography>
      </Box>
    </Container>
  );
};

export default HowToJoin;
